<div class="quick-bet-confirmation-header">
    @if (isUserBalanceEnabled) {
        <span class="header-title">{{ sitecore.quickBetMessages.Balance }}: {{ accountBalance | msCurrency: true }}</span>
    }
    @if (!inOverlay()) {
        <button id="closeResultScreenButtonHeader" ds-button size="medium" variant="outline" kind="secondary" (click)="closeResultScreen()">
            {{ sitecore.quickBetMessages.CloseButton }}
        </button>
    }
</div>
<ms-epcot-notification [message]="sitecore.quickBetMessages.BetPlaceSuccessText" [notificationType]="'success'"></ms-epcot-notification>
<bs-digital-linear-result-slips
    class="betslip-result-summary"
    [succeededSlips]="[resultState()]"
    [oddsDisplayFormat]="oddsDisplayFormat"
    [inColumn]="true"></bs-digital-linear-result-slips>
<div [ngClass]="inOverlay() ? 'quick-bet-confirmation-button-container__overlay' : 'quick-bet-confirmation-button-container'">
    @if (!inOverlay()) {
        <button id="navigateToMyBetsButton" ds-button kind="secondary" variant="outline" (click)="navigateToMyBets()">
            {{ sitecore.betslip.linear.GoToMyBets }}
        </button>
    }
    <button id="closeResultScreenButton" ds-button (click)="closeResultScreen()">{{ sitecore.quickBetMessages.QuickBetDoneText }}</button>
</div>
